module.exports = __webpack_public_path__ + "img/work_typing_computer_notebook_programming_business_technology_internet-883504.717936c5.jpg";